export default "__VITE_ASSET__BgUolIgB__"